module.exports = __webpack_public_path__ + "img/arrow_bi.60516064.svg";